import React, { useState } from "react";
import backgroundImage from "../assets/dtu.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { login } from "../redux/reducers/AuthSlice";
import { setRole } from "../redux/reducers/UserSlice";
import { toast } from "react-hot-toast";
import showPasswordIcon from "../assets/showPasswordIcon.png";
import StickyNavbar from "./Website/Header";
import { HashLink } from "react-router-hash-link";

const Login = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const role = params.get("role") || "student";
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState({
    user_id: "",
    password: "",
    showPassword: false,
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("credentials", credentials);
    try {
      const endpoint = `${process.env.REACT_APP_BACKEND_URL}/ece/${role}/login`;
      const uppercaseUserId = credentials.user_id.toUpperCase();
      const payload = {
        [role === "student"
          ? "roll_no"
          : role === "faculty"
            ? "faculty_id"
            : role === "department"
              ? "department_id"
              : role === "alumni"
                ? "user_id"
                : "user_id"]: uppercaseUserId,
        password: credentials.password,
      };

      const response = await axios.post(endpoint, payload, {
        withCredentials: true,
      });

      const { user } = response.data;
      dispatch(setRole(user.position));
      dispatch(login({ user }));
      console.log("role", role);
      const routes = {
        faculty: "/faculty",
        student: "/student",
        admin: "/admin",
        department: "/department/office-orders",
        alumni: "/alumni",
      };

      navigate(routes[user.position] || "/unauthorized");
      toast.success("Login successful!");
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Invalid credentials";
      toast.error(errorMessage);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const toggleShowPassword = () => {
    setCredentials((prev) => ({ ...prev, showPassword: !prev.showPassword }));
  };

  const fieldLabels = {
    faculty: "Faculty ID",
    student: "Student ID",
    department: "Department ID",
    alumni: "Alumni ID",
    admin: "Admin ID",
  };

  return (
    <>
      <StickyNavbar />
      <div
        className="flex min-h-screen justify-center items-center px-4 py-16"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="w-full max-w-md bg-white rounded-xl shadow-xl p-8 border border-gray-500">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-[#800000] mb-2">
              {`${fieldLabels[role]?.replace(" ID", "") || "User"} Login`}
            </h2>
            <div className="h-1 w-16 bg-[#800000] mx-auto"></div>
          </div>

          <form className="space-y-6" onSubmit={handleLogin}>
            <div>
              <label
                htmlFor="user_id"
                className="block mb-2 font-medium text-gray-700"
              >
                {fieldLabels[role] || "User ID"}
              </label>
              <input
                id="user_id"
                name="user_id"
                autoComplete="username"
                value={credentials.user_id}
                required
                onChange={handleChange}
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#800000] focus:border-transparent transition"
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block mb-2 font-medium text-gray-700"
              >
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={credentials.showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                  value={credentials.password}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#800000] focus:border-transparent transition pr-10"
                />
                <button
                  type="button"
                  onClick={toggleShowPassword}
                  className="absolute inset-y-0 right-3 flex items-center"
                >
                  <img
                    src={showPasswordIcon}
                    alt="Show Password"
                    className="h-5 w-5 opacity-70 hover:opacity-100"
                  />
                </button>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <HashLink
                to="/forgot"
                className="text-sm text-[#800000] font-medium hover:underline"
              >
                Forgot password?
              </HashLink>
            </div>

            <button
              type="submit"
              className="w-full rounded-lg bg-[#800000] py-3 text-white font-semibold hover:bg-[#a10000] transition-colors shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#800000] focus:ring-offset-2"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
